import type { ParamMatcher } from "@sveltejs/kit";
import { isTranslatedLocale } from "$lib/i18n/locales";

// The first segment of a translated address. Only the languages the site is
// published in match, so `/es/pricing` routes to the translated page and an
// address like `/xx/pricing` falls through to "not found" rather than to a page
// in no language. English has no prefix and never matches.
export const match: ParamMatcher = (param) => isTranslatedLocale(param);
